import React from 'react';
import Dialog from "@mui/material/Dialog";
import useHideLocalize from "../../common/hooks/useHideLocalize";

const FicheContext = ({handleClose, isOpen,children}) => {
  useHideLocalize();

  return <Dialog
    onClose={handleClose}
    open={isOpen}
    sx={{
      zIndex: 1299,
      '& .MuiDialog-container': {
        display: 'flex',
        justifyContent: 'flex-end'
      },
      '& .MuiDialog-paper': {
        minWidth: '1041px',
        width: '70%',
        maxWidth: 'unset',
        maxHeight: 'unset',
        height: '100%',
        borderRadius: '0px',
        margin: '0px',
        background: '#F7F8FC'
      }
    }}
  >
    {children}
  </Dialog>
}

export default FicheContext;